import { useEffect, useState } from 'react';

/**
 * Returns a value that updates `delayMs` after the input stops
 * changing. Useful for slider scrubs that drive expensive queries.
 */
export function useDebouncedValue<T>(value: T, delayMs = 250): T {
  const [debounced, setDebounced] = useState<T>(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
